import { render, staticRenderFns } from "./ButtonError.vue?vue&type=template&id=0035fe1a"
import script from "./ButtonError.vue?vue&type=script&lang=ts"
export * from "./ButtonError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports